<!--
# -----------------------------------------------------------------------------
# Component: PolicyRisk.vue
# Author: PST
# Created Date: 02/April/2019
# Comments: Policy Risk main page
# -----------------------------------------------------------------------------
-->
<template>
  <div>
    <v-layout row wrap>
      <v-tabs v-model="polTabs" icons-and-text>
        <v-tab @click.native="doTab(0)">
          Group Details
          <v-icon color="cyan">mdi-group</v-icon>
        </v-tab>
        <v-tab @click.native="doTab(1)">
          Risk Details
          <v-icon color="cyan">mdi-pencil-box-outline</v-icon>
        </v-tab>
        <v-tab @click.native="doTab(2)">
          Coverage
          <v-icon color="cyan">mdi-format-list-bulleted</v-icon>
        </v-tab>
        <v-tab @click.native="doTab(3)">
          Trailer
          <v-icon color="cyan">mdi-history</v-icon>
        </v-tab>
      </v-tabs>
    </v-layout>
    <v-container fluid grid-list-sm>
      <v-layout row wrap>
        <v-flex xs12>
          <router-view ref="childComponent"></router-view>
        </v-flex>
        <confirm v-model="promptSelectRisk" @ok="doSelectRisk"> Select Risk No. in Risk Details </confirm>
      </v-layout>
    </v-container>
    <v-dialog v-model="promptSelectRiskGrp" persistent width="400px">
      <v-card>
        <v-card-text> Please select Risk No. in Risk Details and click Endorse. </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="closeDialog"> OK </v-btn>
          <v-btn color="red" text @click.native="promptSelectRiskGrp = false"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { POLICY_RISK_TAB } from '@/store/types'

export default {
  data() {
    return {
      polTabs: 0,
      headers: 0,
      promptSelectRisk: false,
      promptSelectRiskGrp: false,
      previousTab: undefined
    }
  },
  computed: {
    policyRiskTab() {
      return this.$store.state.underwriting.policy.policyRiskTab
    },
    selectedRiskGrpNo() {
      return this.$store.state.underwriting.policy.selectedRiskGrpNo
    },
    selectedRiskNo() {
      return this.$store.state.underwriting.policy.selectedRiskNo
    }
  },
  watch: {
    policyRiskTab: function(value) {
      this.headers = value
      this.polTabs = value
    }
  },
  methods: {
    doInit() {
      this.headers = this.policyRiskTab
      this.polTabs = this.policyRiskTab
    },
    expandRiskDetails() {
      if (this.$refs.childComponent.busClsAppID === 'BD') {
        if (this.$refs.childComponent.$refs.polBondRisk) {
          this.$refs.childComponent.$refs.polBondRisk.detail_panel = [0]
        }
      } else if (this.$refs.childComponent.busClsAppID === 'FI') {
        if (this.$refs.childComponent.$refs.polFireRisk) {
          this.$refs.childComponent.$refs.polFireRisk.detail_panel = [0]
        }
      } else if (this.$refs.childComponent.busClsAppID === 'MO') {
        if (this.$refs.childComponent.$refs.polMtrRisk) {
          this.$refs.childComponent.$refs.polMtrRisk.detail_panel = [0]
        }
      } else if (this.$refs.childComponent.busClsAppID === 'HU') {
        if (this.$refs.childComponent.$refs.polHullRisk) {
          this.$refs.childComponent.$refs.polHullRisk.detail_panel = [0]
        }
      } else if (this.$refs.childComponent.busClsAppID === 'CA') {
        if (this.$refs.childComponent.$refs.polCargoRisk) {
          this.$refs.childComponent.$refs.polCargoRisk.detail_panel = [0]
        }
      }
    },
    // AR: TODO Backup to be remove *** 23/May
    // 2021-03-05 LYT OS-698
    async doTab(index) {
      this.polTabs = this.policyRiskTab
      if (this.policyRiskTab === 0) {
        this.$refs.childComponent.doTab().then(() => {
          this.changeTab(index)
        })
      } else if (this.policyRiskTab === 1) {
        this.resetMessages()
        this.expandRiskDetails()
        this.$refs.childComponent.doValidateAllWarn().then(result4 => {
          if (result4) {
            this.$validator.validateAll().then(result3 => {
              if (result3) {
                this.$refs.childComponent.policy.loading = true
                this.$refs.childComponent.valPolEmpyeeDet().then(empyeeDetObj => {
                  this.$refs.childComponent.empyeeDetStat.isValid = empyeeDetObj.isValid
                  this.$refs.childComponent.empyeeDetStat.isBlank = empyeeDetObj.isBlank
                  if (Object.keys(empyeeDetObj).length > 0) {
                    this.$refs.childComponent.doWarnEmptyEmpyeeDet()
                  }
                  if (this.$refs.childComponent.acceptEmpyeeDet || this.$refs.childComponent.empyeeDetExist) {
                    this.$refs.childComponent.isExistedPolBondRisk().then(result6 => {
                      if (result6) {
                        if (this.$refs.childComponent.acceptBondNo) {
                          this.$refs.childComponent.valRiskAccum().then(successRiskAccumVal => {
                            if (successRiskAccumVal) {
                              this.$refs.childComponent.valAllRiskStatsVal().then(successVal => {
                                if (successVal) {
                                  // ***
                                  if (this.$refs.childComponent.busClsAppID === 'BD') {
                                    if (this.$refs.childComponent.$refs.polBondRisk) {
                                      this.resetMessages()
                                      this.$refs.childComponent.$refs.polBondRisk.$validator.validateAll().then(result2 => {
                                        if (this.$refs.childComponent.$refs.polBondRisk.workerForm.wrkmanNo !== undefined) {
                                          this.$refs.childComponent.$refs.polBondRisk.$validator.validateAll('workerForm').then(result => {
                                            if (result) {
                                              this.$refs.childComponent.policy.loading = true
                                              this.$refs.childComponent.$refs.polBondRisk.workerForm.polNo = this.$refs.childComponent.$refs.polBondRisk.mainForm.polNo
                                              this.$refs.childComponent.$refs.polBondRisk.workerForm.renCnt = this.$refs.childComponent.$refs.polBondRisk.mainForm.renCnt
                                              this.$refs.childComponent.$refs.polBondRisk.workerForm.endtCnt = this.$refs.childComponent.$refs.polBondRisk.mainForm.endtCnt
                                              this.$refs.childComponent.$refs.polBondRisk.workerForm.riskGrpNo = this.$refs.childComponent.$refs.polBondRisk.mainForm.riskGrpNo
                                              this.$refs.childComponent.$refs.polBondRisk.workerForm.riskNo = this.$refs.childComponent.$refs.polBondRisk.mainForm.riskNo
                                              this.$refs.childComponent.$refs.polBondRisk.doPolMiscWrkmanSave().then(success => {
                                                if (success) {
                                                  this.$refs.childComponent.$refs.polBondRisk.initWorkerForm()
                                                  this.$refs.childComponent.$refs.polBondRisk.displayWorkerList()
                                                  this.$refs.childComponent.$refs.polBondRisk.doPolMiscEmpytSave().then(success2 => {
                                                    if (success2) {
                                                      this.$refs.childComponent.doMiscRiskSave().then(success3 => {
                                                        if (success3) {
                                                          this.changeTab(index)
                                                        } else {
                                                          this.$toast.error('Miscellaneous Risk Details Save Failed')
                                                          this.$refs.childComponent.policy.loading = false
                                                        }
                                                      })
                                                    } else {
                                                      this.$toast.error('Policy Bond Risk Save Failed')
                                                      this.$refs.childComponent.policy.loading = false
                                                    }
                                                  })
                                                } else {
                                                  this.$toast.error('Worker Details Save Failed')
                                                  this.$refs.childComponent.policy.loading = false
                                                }
                                              })
                                            } else {
                                              this.promptFieldCheck()
                                              this.$refs.childComponent.policy.loading = false
                                            }
                                          })
                                        } else if (result2) {
                                          this.$refs.childComponent.policy.loading = true
                                          this.$refs.childComponent.$refs.polBondRisk.doPolMiscEmpytSave().then(success => {
                                            if (success) {
                                              this.$refs.childComponent.doMiscRiskSave().then(success3 => {
                                                if (success3) {
                                                  this.changeTab(index)
                                                } else {
                                                  this.$toast.error('Miscellaneous Risk Details Save Failed')
                                                  this.$refs.childComponent.policy.loading = false
                                                }
                                              })
                                            } else {
                                              this.$toast.error('Policy Bond Risk Save Failed')
                                              this.$refs.childComponent.policy.loading = false
                                            }
                                          })
                                        } else {
                                          this.promptFieldCheck()
                                          this.$refs.childComponent.policy.loading = false
                                        }
                                      })
                                    }
                                  } else if (this.$refs.childComponent.busClsAppID === 'FI') {
                                    if (this.$refs.childComponent.$refs.polFireRisk) {
                                      this.resetMessages()
                                      this.$refs.childComponent.$refs.polFireRisk.$validator.validateAll().then(result => {
                                        if (result) {
                                          this.$refs.childComponent.policy.loading = true
                                          this.$refs.childComponent.$refs.polFireRisk.doPolFireRiskSave().then(success => {
                                            if (success) {
                                              this.$refs.childComponent.doMiscRiskSave().then(success3 => {
                                                if (success3) {
                                                  this.changeTab(index)
                                                } else {
                                                  this.$toast.error('Miscellaneous Risk Details Save Failed')
                                                  this.$refs.childComponent.policy.loading = false
                                                }
                                              })
                                            } else {
                                              this.$toast.error('Policy Fire Risk Save Failed')
                                              this.$refs.childComponent.policy.loading = false
                                            }
                                          })
                                        } else {
                                          this.promptFieldCheck()
                                          this.$refs.childComponent.policy.loading = false
                                        }
                                      })
                                    }
                                  } else if (this.$refs.childComponent.busClsAppID === 'MO') {
                                    if (this.$refs.childComponent.$refs.polMtrRisk) {
                                      this.resetMessages()
                                      this.$refs.childComponent.$refs.polMtrRisk.$validator.validateAll().then(result2 => {
                                        if (this.$refs.childComponent.$refs.polMtrRisk.driverForm.seqNo !== undefined) {
                                          this.$refs.childComponent.$refs.polMtrRisk.$validator.validateAll('driverForm').then(result => {
                                            if (result) {
                                              this.$refs.childComponent.policy.loading = true
                                              this.$refs.childComponent.$refs.polMtrRisk.driverForm.polNo = this.$refs.childComponent.$refs.polMtrRisk.mainForm.polNo
                                              this.$refs.childComponent.$refs.polMtrRisk.driverForm.renCnt = this.$refs.childComponent.$refs.polMtrRisk.mainForm.renCnt
                                              this.$refs.childComponent.$refs.polMtrRisk.driverForm.endtCnt = this.$refs.childComponent.$refs.polMtrRisk.mainForm.endtCnt
                                              this.$refs.childComponent.$refs.polMtrRisk.driverForm.riskGrpNo = this.$refs.childComponent.$refs.polMtrRisk.mainForm.riskGrpNo
                                              this.$refs.childComponent.$refs.polMtrRisk.driverForm.riskNo = this.$refs.childComponent.$refs.polMtrRisk.mainForm.riskNo
                                              this.$refs.childComponent.$refs.polMtrRisk.doPolMtrDrvSave().then(success => {
                                                if (success) {
                                                  this.$refs.childComponent.$refs.polMtrRisk.initDriverForm()
                                                  this.$refs.childComponent.$refs.polMtrRisk.displayDriverList()
                                                  this.$refs.childComponent.$refs.polMtrRisk.doPolMtrRiskSave().then(success2 => {
                                                    if (success2) {
                                                      this.$refs.childComponent.doMiscRiskSave().then(success3 => {
                                                        if (success3) {
                                                          this.changeTab(index)
                                                        } else {
                                                          this.$toast.error('Miscellaneous Risk Details Save Failed')
                                                          this.$refs.childComponent.policy.loading = false
                                                        }
                                                      })
                                                    } else {
                                                      this.$toast.error('Policy Motor Risk Save Failed')
                                                      this.$refs.childComponent.policy.loading = false
                                                    }
                                                  })
                                                } else {
                                                  this.$toast.error('Named Driver Save Failed')
                                                  this.$refs.childComponent.policy.loading = false
                                                }
                                              })
                                            } else {
                                              this.promptFieldCheck()
                                              this.$refs.childComponent.policy.loading = false
                                            }
                                          })
                                        } else if (result2) {
                                          this.$refs.childComponent.policy.loading = true
                                          this.$refs.childComponent.$refs.polMtrRisk.doPolMtrRiskSave().then(success => {
                                            if (success) {
                                              this.$refs.childComponent.doMiscRiskSave().then(success3 => {
                                                if (success3) {
                                                  this.changeTab(index)
                                                } else {
                                                  this.$toast.error('Miscellaneous Risk Details Save Failed')
                                                  this.$refs.childComponent.policy.loading = false
                                                }
                                              })
                                            } else {
                                              this.$toast.error('Policy Motor Risk Save Failed')
                                              this.$refs.childComponent.policy.loading = false
                                            }
                                          })
                                        } else {
                                          this.promptFieldCheck()
                                          this.$refs.childComponent.policy.loading = false
                                        }
                                      })
                                    }
                                  } else if (this.$refs.childComponent.busClsAppID === 'HU') {
                                    if (this.$refs.childComponent.$refs.polHullRisk) {
                                      this.resetMessages()
                                      this.$refs.childComponent.$refs.polHullRisk.$validator.validateAll().then(result => {
                                        if (result) {
                                          this.$refs.childComponent.policy.loading = true
                                          this.$refs.childComponent.$refs.polHullRisk.doPolHullRiskSave().then(success => {
                                            if (success) {
                                              this.$refs.childComponent.doMiscRiskSave().then(success3 => {
                                                if (success3) {
                                                  this.changeTab(index)
                                                } else {
                                                  this.$toast.error('Miscellaneous Risk Details Save Failed')
                                                  this.$refs.childComponent.policy.loading = false
                                                }
                                              })
                                            } else {
                                              this.$toast.error('Policy Hull Risk Save Failed')
                                              this.$refs.childComponent.policy.loading = false
                                            }
                                          })
                                        } else {
                                          this.promptFieldCheck()
                                          this.$refs.childComponent.policy.loading = false
                                        }
                                      })
                                    }
                                  } else if (this.$refs.childComponent.busClsAppID === 'CA') {
                                    if (this.$refs.childComponent.$refs.polCargoRisk) {
                                      this.resetMessages()
                                      this.$refs.childComponent.$refs.polCargoRisk.$validator.validateAll().then(result => {
                                        if (result) {
                                          this.$refs.childComponent.policy.loading = true
                                          this.$refs.childComponent.$refs.polCargoRisk.doPolCargoRiskSave().then(success => {
                                            if (success) {
                                              this.$refs.childComponent.doMiscRiskSave().then(success3 => {
                                                if (success3) {
                                                  this.changeTab(index)
                                                } else {
                                                  this.$toast.error('Miscellaneous Risk Details Save Failed')
                                                  this.$refs.childComponent.policy.loading = false
                                                }
                                              })
                                            } else {
                                              this.$toast.error('Policy Hull Risk Save Failed')
                                              this.$refs.childComponent.policy.loading = false
                                            }
                                          })
                                        } else {
                                          this.promptFieldCheck()
                                          this.$refs.childComponent.policy.loading = false
                                        }
                                      })
                                    }
                                  } else if (this.$refs.childComponent.busClsAppID === 'MI' || this.$refs.childComponent.busClsAppID === 'TR') {
                                    this.resetMessages()
                                    this.$refs.childComponent.doMiscRiskSave().then(success => {
                                      if (success) {
                                        this.changeTab(index)
                                      } else {
                                        this.$toast.error('Miscellaneous Risk Details Save Failed')
                                        this.$refs.childComponent.policy.loading = false
                                        this.$refs.childComponent.getIndGrp()
                                      }
                                    })
                                  }
                                  // ***
                                } else {
                                  this.$refs.childComponent.policy.loading = false
                                }
                              })
                            } else {
                              this.$refs.childComponent.policy.loading = false
                            }
                          })
                        } else {
                          this.$refs.childComponent.policy.loading = false
                        }
                      } else {
                        this.$refs.childComponent.policy.loading = false
                      }
                    })
                  } else {
                    this.$refs.childComponent.policy.loading = false
                  }
                })
              } else {
                this.promptFieldCheck()
                this.$refs.childComponent.policy.loading = false
              }
            })
          }
        })
      } else if (this.policyRiskTab === 2) {
        this.doTabPolCov(index)
      } else if (this.policyRiskTab === 3) {
        this.resetMessages()
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$refs.childComponent.policy.saving = true
            this.$refs.childComponent.saveRiskTrailers().then(success => {
              if (success) {
                this.changeTab(index)
              } else {
                this.$toast.error('Risk Trailer Save Failed')
              }
              this.$refs.childComponent.policy.saving = false
            })
          } else {
            this.promptFieldCheck()
          }
        })
      }
    },
    async doTabPolCov(index) {
      this.$refs.childComponent.policy.loading = true
      this.$refs.childComponent.policy.saving = true
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$refs.childComponent.doSave().then(output => {
            if (output === 'SUCCESS' || output === 'NOCHANGE') {
              this.changeTab(index)
            }
          })
        } else {
          this.promptFieldCheck()
        }
        this.$refs.childComponent.policy.loading = false
        this.$refs.childComponent.policy.saving = false
      })
    },
    // 2021-03-05 LYT OS-698
    // TODO: Backup. To be remove
    async doTab2(index) {
      if (index === 0) {
        this.changeTab(index)
      } else if (index === 1) {
        this.resetMessages()
        this.$validator.validateAll().then(result1 => {
          if (result1) {
            if (this.headers === 0) {
              this.$refs.childComponent.doProceed()
            } else {
              this.changeTab(index)
            }
          } else {
            this.promptFieldCheck()
          }
        })
      } else if (index === 2) {
        this.resetMessages()
        this.$validator.validateAll().then(result2 => {
          if (result2) {
            this.$refs.childComponent.valPolEmpyeeDet().then(success => {
              if (success) {
                // AR: TODO check if MI = Miscellenous need validation
                if (this.headers === 1 && this.$refs.childComponent.busClsAppID !== 'MI' && this.$refs.childComponent.busClsAppID !== 'TR') {
                  this.$refs.childComponent.doValidateRisk(index)
                } else {
                  this.changeTab(index)
                }
              }
              // else {
              //   this.changeTab(1)
              // }
            })
          } else {
            this.promptFieldCheck()
          }
        })
      } else if (index === 3) {
        this.resetMessages()
        this.$validator.validateAll().then(result3 => {
          if (result3) {
            this.$refs.childComponent.valPolEmpyeeDet().then(success => {
              if (success) {
                // AR: TODO check if MI = Miscellenous need validation
                if (this.headers === 1 && this.$refs.childComponent.busClsAppID !== 'MI' && this.$refs.childComponent.busClsAppID !== 'TR') {
                  this.$refs.childComponent.doValidateRisk(index)
                } else {
                  this.changeTab(index)
                }
              }
              // else {
              //   this.changeTab(1)
              // }
            })
          } else {
            this.promptFieldCheck()
          }
        })
      }
    },
    changeTab(index) {
      if (index === 0) {
        this.headers = 0
        this.$store.commit(POLICY_RISK_TAB, 0)
        this.$router.push({ name: 'policyRisk' })
      } else if (index === 1) {
        if (this.selectedRiskGrpNo !== undefined) {
          this.headers = 1
          this.$store.commit(POLICY_RISK_TAB, 1)
          this.$router.push({ name: 'policyRiskDetails' })
        } else {
          this.promptSelectRiskGrp = true
        }
      } else if (index === 2) {
        if (this.selectedRiskGrpNo !== undefined) {
          if (this.selectedRiskNo !== undefined) {
            this.headers = 2
            this.$store.commit(POLICY_RISK_TAB, 2)
            this.$router.push({ name: 'policyCoverage' })
          } else {
            this.promptSelectRisk = true
          }
        } else {
          this.promptSelectRiskGrp = true
        }
      } else if (index === 3) {
        if (this.selectedRiskGrpNo !== undefined) {
          if (this.selectedRiskNo !== undefined) {
            this.headers = 3
            this.$store.commit(POLICY_RISK_TAB, 3)
            this.$router.push({ name: 'policyRiskTrailer' })
          } else {
            this.promptSelectRisk = true
          }
        } else {
          this.promptSelectRiskGrp = true
        }
      }
      this.polTabs = this.headers
    },
    changeGroupDetails() {
      this.$router.push({ name: 'policyRisk' })
    },
    changeRiskDetails() {
      this.$router.push({ name: 'policyRiskDetails' })
    },
    changeCoverage() {
      this.$router.push({ name: 'policyCoverage' })
    },
    doSelectRisk() {
      this.headers = 1
      this.$store.commit(POLICY_RISK_TAB, 1)
      this.$router.push({ name: 'policyRiskDetails' })
    },
    closeDialog() {
      this.promptSelectRiskGrp = false
    },
    successMessage() {
      return 'Policy record successfully saved.'
    },
    failedMessage(module) {
      if (module === '' || module === undefined) {
        return 'An unexpected error occured while saving policy record.'
      } else {
        return 'An unexpected error occured while saving ' + module + ' record.'
      }
    },
    // 2020-11-20 LYT OS-576
    setTabs(index) {
      this.polTabs = index
    }
  },
  beforeMount() {
    // 2020-10-01 LYT Fixed Invalid URL
    if (this.$store.state.underwriting.policyHeaderSettings.init !== 1) {
      this.$store.dispatch('policyHeaderInit')
    }
    this.doInit()
  },
  mixins: [MessageMixin]
}
</script>

<style lang="scss">
@import '../../../../assets/scss/underwriting.scss';
</style>
